<template>
  <layout>
    <div>
      <h1 style="display:inline-block" class="h3 mb-3 text-gray-800">Perfil Particular</h1>
    </div>
    <div class="row">
      <div class="card col-12">
        <div class="card-body">
          <h3 class="h3 text-black-900">{{user.first_name}} {{user.last_name}}</h3>
          <div>
            <span>
              <strong>POBOX:{{" "}}</strong>
            </span>
            <span>{{user.po_box}}</span>
          </div>
          <div>
            <span>
              <strong>Email: {{" "}}</strong>
            </span>
            <span>{{user.email}}</span>
          </div>
          <div>
            <span>
              <strong>Documento {{tipo_documento}}: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.documento}}</span>
          </div>
          <div>
            <span>
              <strong>Identificador Fiscal {{tipo_identificador_fiscal}}: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.identificador_fiscal}}</span>
          </div>
          <div>
            <span>
              <strong>Fecha de Nacimiento: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.fecha_nacimiento}}</span>
          </div>
          <div>
            <span>
              <strong>Telefono: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.telefono}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6 pr-2">
        <div class="card">
          <div class="card-body">
            <h3 class="h3 text-black-900">Domicilio de Entrega</h3>
            <div>
              <span>
                <strong>Direccion:{{" "}}</strong>
              </span>
              <span>{{user.particular_profile.domicilio.direccion}}</span>
            </div>
            <div>
              <span>
                <strong>Piso: {{" "}}</strong>
              </span>
              <span>{{user.particular_profile.domicilio.piso ? user.particular_profile.domicilio.piso : "N/A"}}</span>
            </div>
            <div>
              <span>
                <strong>Departamento: {{" "}}</strong>
              </span>
              <span>{{user.particular_profile.domicilio.departamento  ? user.particular_profile.domicilio.departamento : "N/A"}}</span>
            </div>
            <div>
              <span>
                <strong>Ciudad: {{" "}}</strong>
              </span>
              <span>{{user.particular_profile.domicilio.ciudad}}</span>
            </div>
            <div>
              <span>
                <strong>Provincia: {{" "}}</strong>
              </span>
              <span>{{user.particular_profile.domicilio.provincia}}</span>
            </div>
            <div>
              <span>
                <strong>Codigo Postal: {{" "}}</strong>
              </span>
              <span>{{user.particular_profile.domicilio.codigo_postal}}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card col-6">
        <div class="card-body">
          <h3 class="h3 text-black-900">Domicilio Fiscal</h3>
          <div>
            <span>
              <strong>Direccion:{{" "}}</strong>
            </span>
            <span>{{user.particular_profile.domicilio_legal.direccion}}</span>
          </div>
          <div>
            <span>
              <strong>Piso: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.domicilio_legal.piso ? user.particular_profile.domicilio_legal.piso : "N/A"}}</span>
          </div>
          <div>
            <span>
              <strong>Departamento: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.domicilio_legal.departamento ? user.particular_profile.domicilio_legal.departamento : "N/A"}}</span>
          </div>
          <div>
            <span>
              <strong>Ciudad: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.domicilio_legal.ciudad}}</span>
          </div>
          <div>
            <span>
              <strong>Provincia: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.domicilio_legal.provincia}}</span>
          </div>
          <div>
            <span>
              <strong>Codigo Postal: {{" "}}</strong>
            </span>
            <span>{{user.particular_profile.domicilio_legal.codigo_postal}}</span>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>
<script>
import Layout from "../layout/Layout.vue";
export default {
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  components: { Layout },
  data() {
    return {
      nombre: "Esteban",
      apellido: "Bisocoli",
      email: "estebaanbisocoli@gmail.com",
      pobox: "7548",
      tipo_documento: "DNI",
      documento: 38800209,
      tipo_identificador_fiscal: "CUIL",
      identificador_fiscal: 20388002094,
      fecha_nacimiento: "06/11/1995",
      telefono: "2945400703",
      domicilio: {
        direccion: "Av 19 658",
        piso: "",
        departamento: 3,
        ciudad: "La Plata",
        provincia: "Buenos Aires",
        codigo_postal: 9200,
      },
      domicilio_fiscal: {
        direccion: "Av 19 658",
        piso: "",
        departamento: 3,
        ciudad: "La Plata",
        provincia: "Buenos Aires",
        codigo_postal: 9200,
      },
    };
  },
};
</script>
<style scoped>
.header {
}
</style>